import { Box, BoxProps, Paper, Theme, styled } from '@material-ui/core';
import { DraggableItemIcon, DraggableItemIconProps } from './DraggableItemIcon';
import { DraggableItemFAIcon, DraggableItemFAIconProps } from './DraggableItemFAIcon';

export const StyledWrapper = styled(Paper)<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
  boxShadow: 'none',
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  borderRadius: theme.config.defaultBorderRadius,
}));

export const StyledContent = styled(Box)<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  boxShadow: 'none',
}));

export const StyledIconWrapper = styled(Box)<Theme, BoxProps>(({ theme, bgcolor, color }) => ({
  padding: theme.spacing(1),
  alignItems: 'center',
  border: 'none',
  boxShadow: 'none',
  display: 'flex',
  backgroundColor: bgcolor,
  cursor: 'pointer',
  color,
}));

export const StyledDraggableItemIcon = styled(DraggableItemIcon)<Theme, DraggableItemIconProps>(
  ({ theme, component, onClick, left, right }) => ({
    cursor: component === 'button' || !!onClick ? 'pointer' : 'default',
    borderRadius: left
      ? `${theme.config.defaultBorderRadius} 0 0 ${theme.config.defaultBorderRadius}`
      : right
      ? `0 ${theme.config.defaultBorderRadius} ${theme.config.defaultBorderRadius} 0`
      : '0',
  })
);

export const StyledDraggableItemFAIcon = styled(DraggableItemFAIcon)<
  Theme,
  DraggableItemFAIconProps
>(({ theme, component, onClick, left, right }) => ({
  // cursor: component === 'button' || !!onClick ? 'pointer' : 'default',
  cursor: 'pointer',
  borderRadius: left
    ? `${theme.config.defaultBorderRadius} 0 0 ${theme.config.defaultBorderRadius}`
    : right
    ? `0 ${theme.config.defaultBorderRadius} ${theme.config.defaultBorderRadius} 0`
    : '0',
}));
